import React from 'react';
import styles from './PreviewParts.module.css';

/**
 * Peças da prévia falsa das telas bloqueadas (AccessDenied com `preview`).
 * Só recebem dados de exemplo fixos no código: nunca dados reais nem API.
 */

/** Cabeçalho da tela: ícone, título e uma linha de apoio. */
export const PreviewHeader = ({ icon, title, subtitle }) => (
  <div className={styles.header}>
    <span className={styles.headerIcon}>{icon}</span>
    <div>
      <div className={styles.headerTitle}>{title}</div>
      {subtitle && <div className={styles.headerSubtitle}>{subtitle}</div>}
    </div>
  </div>
);

/** Abas da tela, com a primeira ativa. */
export const PreviewTabs = ({ labels }) => (
  <div className={styles.tabs}>
    {labels.map((label, index) => (
      <span key={label} className={index === 0 ? styles.tabActive : styles.tab}>{label}</span>
    ))}
  </div>
);

/** Cartão com título opcional. */
export const PreviewPanel = ({ title, children }) => (
  <div className={styles.panel}>
    {title && <div className={styles.panelTitle}>{title}</div>}
    {children}
  </div>
);

/** Linha de indicadores: [{ label, value }]. */
export const PreviewKpis = ({ items }) => (
  <div className={styles.kpis}>
    {items.map(({ label, value }) => (
      <div key={label} className={styles.kpi}>
        <span className={styles.kpiLabel}>{label}</span>
        <span className={styles.kpiValue}>{value}</span>
      </div>
    ))}
  </div>
);

/** Tabela simples: colunas e linhas de texto. */
export const PreviewTable = ({ columns, rows }) => (
  <div className={styles.table}>
    <div className={styles.row} style={{ gridTemplateColumns: `repeat(${columns.length}, 1fr)` }}>
      {columns.map((column) => <span key={column} className={styles.th}>{column}</span>)}
    </div>
    {rows.map((row, rowIndex) => (
      <div key={rowIndex} className={styles.row} style={{ gridTemplateColumns: `repeat(${columns.length}, 1fr)` }}>
        {row.map((cell, cellIndex) => <span key={cellIndex} className={styles.td}>{cell}</span>)}
      </div>
    ))}
  </div>
);

/** Gráfico de barras em porcentagem (0-100). */
export const PreviewBars = ({ values }) => (
  <div className={styles.bars}>
    {values.map((value, index) => (
      <span key={index} className={styles.bar} style={{ height: `${value}%` }} />
    ))}
  </div>
);

/** Linhas de texto cinza, como um parágrafo ainda por ler. */
export const PreviewLines = ({ widths = [92, 78, 85, 60] }) => (
  <div className={styles.lines}>
    {widths.map((width, index) => <span key={index} className={styles.line} style={{ width: `${width}%` }} />)}
  </div>
);

/** Duas colunas que viram uma no estreito. */
export const PreviewGrid = ({ children }) => <div className={styles.grid}>{children}</div>;

/** Coluna da prévia inteira. */
export const PreviewPage = ({ children }) => <div className={styles.page}>{children}</div>;
